import { useAccount } from '~/hooks/useAccount';
import { useGetActiveLoansQuery } from '~/store/apis/endpoints/myQredApi/loan/loans.api';
import posthog from 'posthog-js';

export const useDirectDebit = () => {
  const { selectedCompany, market } = useAccount();
  const { data: allActiveLoans } = useGetActiveLoansQuery(
    {
      companyId: selectedCompany.id,
      market,
    },
    { refetchOnMountOrArgChange: true }
  );

  const hasApplicantSigner = allActiveLoans?.some(
    (loan) => loan.signer?.type === 'Applicant'
  );
  const showPaymentTab =
    posthog.isFeatureEnabled('Payment_Options_SepaDirectDebit_Release') &&
    hasApplicantSigner;

  return {
    allActiveLoans,
    showPaymentTab,
  };
};
